var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 52,
    viewBox: "0 0 30 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9749 28.4749C30.3417 27.108 30.3417 24.892 28.9749 23.5251L6.70101 1.25126C5.33418 -0.115572 3.1181 -0.115572 1.75126 1.25126C0.384428 2.6181 0.384428 4.83418 1.75126 6.20101L21.5503 26L1.75126 45.799C0.384428 47.1658 0.384428 49.3819 1.75126 50.7487C3.1181 52.1156 5.33418 52.1156 6.70101 50.7487L28.9749 28.4749ZM24 29.5H26.5V22.5H24V29.5Z",
    fill: "#A3A3A3",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3fff32725ddf178504c177e77f592a1b.svg";
export { ForwardRef as ReactComponent };